import { FC } from 'react'

import { formatCurrencyCent } from 'commons/utils'
import { PageSectionSecondary } from 'ui/components'

import { HRRBankAccount } from '../../../../types'

import * as SC from './styles'

export const SalesToDepositComparison: FC<{ bankAccount: HRRBankAccount }> = ({ bankAccount }) => {
  const { comparison } = bankAccount

  return (
    <PageSectionSecondary face="outlined" title="Sales To Deposit Comparison">
      <SC.WrappedLayer rounded shadowed>
        <SC.Table>
          <tbody>
            <tr>
              <SC.Td>Total Cannabis Sales</SC.Td>
              <SC.Td>{formatCurrencyCent(comparison.sales)}</SC.Td>
            </tr>
            <tr>
              <SC.Td>Non-Cannabis Sales</SC.Td>
              <SC.Td>{formatCurrencyCent(comparison.nonCannabisSales)}</SC.Td>
            </tr>
            <tr>
              <SC.Td>Estimated Sales Tax</SC.Td>
              <SC.Td>{formatCurrencyCent(comparison.estimatedSalesTax)}</SC.Td>
            </tr>
            <tr>
              <SC.Td>Total Sales</SC.Td>
              <SC.Td>{formatCurrencyCent(comparison.totalSales)}</SC.Td>
            </tr>
            <tr>
              <SC.Td>Total Deposits</SC.Td>
              <SC.Td>{formatCurrencyCent(comparison.totalDeposits)}</SC.Td>
            </tr>
            <tr>
              <SC.Td>$ Difference</SC.Td>
              <SC.Td>{formatCurrencyCent(comparison.differenceAbsolute)}</SC.Td>
            </tr>
            <tr>
              <SC.Td>% Difference</SC.Td>
              <SC.Td $alerted={comparison.differenceRelative.alerted}>
                {comparison.differenceRelative.percent.toString() === '-1.00'
                  ? 'N/A'
                  : `${comparison.differenceRelative.percent} %`}
              </SC.Td>
            </tr>
          </tbody>
        </SC.Table>
      </SC.WrappedLayer>
    </PageSectionSecondary>
  )
}
